import { Switch, TimePicker } from 'antd';
import React from 'react';
import { useIntl } from 'react-intl';
import dayjs from 'dayjs';
import { padZero } from '../../../utils';
import styles from './DayController.styles';

const DayController = ({ day, hours, onChange }) => {
  const intl = useIntl();

  const startTime = dayjs(
    `${padZero(hours.openAtHour)}:${padZero(hours.openAtMinute)}`,
    'HH:mm'
  );
  const endTime = dayjs(
    `${padZero(hours.closeAtHour)}:${padZero(hours.closeAtMinute)}`,
    'HH:mm'
  );

  const onChangeTime = (timeString) => {
    const [startHour, startMinute] = timeString[0].split(':');
    const [endHour, endMinute] = timeString[1].split(':');
    onChange((prevState) => ({
      ...prevState,
      [day]: {
        ...prevState[day],
        openAtHour: parseInt(startHour),
        openAtMinute: parseInt(startMinute),
        closeAtHour: parseInt(endHour),
        closeAtMinute: parseInt(endMinute),
      },
    }));
  };

  return (
    <>
      <div className="day-wrapper">
        <span className="day-title">
          {intl.formatMessage({
            id: `fleetadmin.${day.toLowerCase()}`,
          })}
        </span>
        <TimePicker.RangePicker
          format={'HH:mm'}
          getPopupContainer={(trigger) => trigger.parentElement}
          disabled={hours.closedWholeDay}
          defaultValue={[startTime, endTime]}
          onChange={(_, timeString) => onChangeTime(timeString)}
        />
        <div className="switch-wrapper">
          <Switch
            checkedChildren={intl.formatMessage({
              id: `closed`,
            })}
            unCheckedChildren={intl.formatMessage({
              id: `open`,
            })}
            defaultValue={hours.closedWholeDay}
            onChange={(e) =>
              onChange((prevState) => ({
                ...prevState,
                [day]: {
                  ...prevState[day],
                  closedWholeDay: e,
                },
              }))
            }
          />
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default DayController;
